import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProductOfferingPrices } from 'app/entities/product-offering-price/product-offering-price.reducer';
import { TaxTariffType } from 'app/shared/model/enumerations/tax-tariff-type.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';
import { createEntity, getEntity, reset, updateEntity } from './tax-tariff-tranche.reducer';

export const TaxTariffTrancheUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const productOfferingPrices = useAppSelector(state => state.productOfferingPrice.entities);
  const taxTariffTrancheEntity = useAppSelector(state => state.taxTariffTranche.entity);
  const loading = useAppSelector(state => state.taxTariffTranche.loading);
  const updating = useAppSelector(state => state.taxTariffTranche.updating);
  const updateSuccess = useAppSelector(state => state.taxTariffTranche.updateSuccess);
  const taxTariffTypeValues = Object.keys(TaxTariffType);
  const productTypeValues = Object.keys(ProductType);

  const handleClose = () => {
    navigate('/tax-tariff-tranche');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProductOfferingPrices({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.trancheLowerBound !== undefined && typeof values.trancheLowerBound !== 'number') {
      values.trancheLowerBound = Number(values.trancheLowerBound);
    }
    if (values.trancheUpperBound !== undefined && typeof values.trancheUpperBound !== 'number') {
      values.trancheUpperBound = Number(values.trancheUpperBound);
    }

    const entity = {
      ...taxTariffTrancheEntity,
      ...values,
      productOfferingPrices: mapIdList(values.productOfferingPrices),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          type: 'TRANCHE_0_TO_2900_KWH',
          productType: 'ELECTRICITY',
          ...taxTariffTrancheEntity,
          productOfferingPrices: taxTariffTrancheEntity?.productOfferingPrices?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.taxTariffTranche.home.createOrEditLabel"
            data-cy="TaxTariffTrancheCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.taxTariffTranche.home.createOrEditLabel">
              Create or edit a TaxTariffTranche
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="tax-tariff-tranche-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTranche.type')}
                id="tax-tariff-tranche-type"
                name="type"
                data-cy="type"
                type="select"
              >
                {taxTariffTypeValues.map(taxTariffType => (
                  <option value={taxTariffType} key={taxTariffType}>
                    {translate(`crawlerBackendApp.TaxTariffType.${taxTariffType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTranche.productType')}
                id="tax-tariff-tranche-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {productTypeValues.map(productType => (
                  <option value={productType} key={productType}>
                    {translate(`crawlerBackendApp.ProductType.${productType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTranche.trancheLowerBound')}
                id="tax-tariff-tranche-trancheLowerBound"
                name="trancheLowerBound"
                data-cy="trancheLowerBound"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTranche.trancheUpperBound')}
                id="tax-tariff-tranche-trancheUpperBound"
                name="trancheUpperBound"
                data-cy="trancheUpperBound"
                type="text"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.taxTariffTranche.productOfferingPrice')}
                id="tax-tariff-tranche-productOfferingPrice"
                data-cy="productOfferingPrice"
                type="select"
                multiple
                name="productOfferingPrices"
              >
                <option value="" key="0" />
                {productOfferingPrices
                  ? productOfferingPrices.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/tax-tariff-tranche"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TaxTariffTrancheUpdate;
